export default {
  'component.globalHeader.searchPlaceholder': '搜索'
};
